/* unplugin-vue-components disabled */import { render } from "./articleList.vue?vue&type=template&id=1bbbb911"
import script from "./articleList.vue?vue&type=script&lang=js"
export * from "./articleList.vue?vue&type=script&lang=js"

import "./articleList.vue?vue&type=style&index=0&id=1bbbb911&lang=css"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿中文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__